import { render, staticRenderFns } from "./LoyaltyConsentModal.vue?vue&type=template&id=5688e971"
import script from "./LoyaltyConsentModal.vue?vue&type=script&lang=js"
export * from "./LoyaltyConsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports